import { NamedError } from "../utils/Errors";

export class BootError extends NamedError<BootErrors> {}

export enum BootErrors {
    IndexeddbFailedToOpen = 'IndexeddbFailedToOpen',
    InvalidLoadTranscriptionStringsPromise = 'InvalidLoadTranscriptionStringsPromise',
    MaxBootTimeReached = 'MaxBootTimeReached'
}

